import { isOrderEditable } from '@cutr/constants/windows/windows';
import { useTranslation } from 'react-i18next';

import { RouterButton } from '@/primitives/Button';
import { ArrowLeft, Icon } from '@/primitives/Icons';

import { useWindowLoaderData } from '../api/windowStore';
import { OrderTitle } from '../blocks/OrderTitle';
import { QuoteSummary } from '../blocks/QuoteSummary';
import { CustomerPriceBlock } from '../interfaces/CustomerPriceBlock';
import { OrderSummary } from '../interfaces/OrderSummary';
import { QuoteSummaryResellerFooter } from '../interfaces/QuoteSummaryResellerFooter';
import { OrderLoaderType } from '../queries/order/loaders';
import styles from './ResellerOrderReview.module.css';

export const ResellerOrderReview = () => {
  const { t } = useTranslation();
  const order = useWindowLoaderData();

  const isEditable = isOrderEditable(order.status);

  return (
    <div className={styles.content}>
      <OrderTitle readonly={!isEditable} />
      {isEditable && (
        <div
          className="flexAlign"
          style={{
            paddingBottom: 'var(--space-m)',
            maxWidth: '1512px',
            margin: '0 auto',
          }}
        >
          <RouterButton
            to={`/windows/orders/${order.id}/configuration`}
            icon={<Icon icon={<ArrowLeft />} />}
            variant="secondary"
            style={{ backgroundColor: 'var(--gray-1)' }}
          >
            {t('reseller.cta.backToOrder')}
          </RouterButton>
          <h3>{t('reseller.orderReview.title.reviewQuote')}</h3>
        </div>
      )}

      <section className={styles.layout}>
        <main>
          <OrderSummary order={order} />
        </main>
        <aside>
          <QuoteSummaryBlock order={order} />
          <CustomerPriceBlock order={order} />
        </aside>
      </section>
    </div>
  );
};

const QuoteSummaryBlock = ({ order }: { order: OrderLoaderType }) => {
  return (
    <div className={styles.quoteContainer}>
      <QuoteSummary order={order}>
        <QuoteSummaryResellerFooter order={order} />
      </QuoteSummary>
    </div>
  );
};
